import React, { useEffect, useState } from "react";
import { Button, Dialog, DialogContent, DialogTitle, DialogContentText, DialogActions, Tooltip, TextField } from "@mui/material";
import { projectManageAxios as axios } from "../../../utils/AxiosUtility";
import { externalApiAxios as hsAxios } from "../../../utils/AxiosUtility";

export function OpenClosePreSaleButton(props) {
  // eslint-disable-next-line
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [dialogTitle, setDialogTitle] = useState("");
  const [preSaleLead, setPreSaleLead] = useState([]);
  const [preSaleTask, setPreSaleTask] = useState([]);
  const [pmNote, setPmNote] = useState("");

  const handleClosePreSale = () => {
    const status = {
      preLeadId: props.preleadId,
      dealStatus: "Closed",
      dealStatusNotes: pmNote !== "" ? pmNote : "Engineering has been closed by PM.  Re-open deal to re-engage Proj Mgmt.",
    }
    let dataToUpload = {
      "preLeadId": props.preleadId,
      "pmAssigned": preSaleTask.pmAssigned,
      "dealStatus": "Closed",
      "dealStatusNotes": pmNote !== "" ? pmNote : "Engineering has been closed by PM.  Re-open deal to re-engage Proj Mgmt.",
    }
    if (preSaleLead == null) {
      alert("Lead not found.");
    }
    else {
      axios.post("/api/PreSales/updatePreSaleLeadStatus", status)
          .then((response) => {
            fetchData();
          })
          .catch((error) => {
            alert("Error updating lead status.");
          })
          .finally(()=> {
            if (props.listener != null) {props.setListener(props.listener + 1)};
            hsAxios.patch("/api/HubSpot/updateDealInfo", dataToUpload)
                .then((response) => {
                })
                .catch((error) => {
                  alert("Error updating task in Hubspot.");
                });
          })
        
    }
  }

  const handleOpenPreSale = () => {
    const status = {
      preLeadId: props.preleadId,
      dealStatus: "Open",
      dealStatusNotes: pmNote !== "" ? pmNote : "Engineering has been re-opened by PM.",
    }
    let dataToUpload = {
      "preLeadId": props.preleadId,
      "pmAssigned": preSaleTask.pmAssigned,
      "dealStatus": "Open",
      "dealStatusNotes": pmNote !== "" ? pmNote : "Engineering has been re-opened by PM.",
    }
    if (preSaleLead == null) {
      alert("Lead not found.");
    }
    else {
      axios.post("/api/PreSales/updatePreSaleLeadStatus", status)
          .then((response) => {
            fetchData();
          })
          .catch((error) => {
            alert("Error updating lead status.");
          })
          .finally(()=> {
            if (props.listener != null) {props.setListener(props.listener + 1)};
            hsAxios.patch("/api/HubSpot/updateDealInfo", dataToUpload)
                .then((response) => {
                })
                .catch((error) => {
                  alert("Error updating task in Hubspot.");
                });
          })

    }
  }

  const fetchData = () => {
    if (props.preleadId) {
      setLoading(true);
      axios.get('api/PreSales/pslead/' + props.preleadId)
        .then((response) => {
          setPreSaleLead(response.data);
          setLoading(false);
        })
        .catch((error) => {
          alert("Open/Close Button: Error retreiving pslead data.");
        });

      axios.get('api/PreSales/pstask/' + props.preleadId)
        .then((response) => {
          setPreSaleTask(response.data);
          setLoading(false);
        })
        .catch((error) => {
          alert("Open/Close Button: Error retreiving pstask data.");
        });
    }
  }

  const handleConfirm = () => {
    if (dialogTitle === "Close Pre-Sale?") {
      handleClosePreSale();
    } else {
      handleOpenPreSale();
    }
    setOpen(false);
  }

  const handleCloseDialog = () => {
    setOpen(false);
  }

  const handleOpenPSDialog = () => {
    setDialogTitle("Open Pre-Sale?");
    setOpen(true);
  }

  const handleClosePSDialog = () => {
    setDialogTitle("Close Pre-Sale?");
    setOpen(true);
  }

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
      fetchData();
    // eslint-disable-next-line
  }, [props.buttonRefresh]);

  return (
    <>
      {preSaleLead.dealStatus !== "Contracted" ? (
        preSaleLead.dealStatus === "Open" ? (
          <Tooltip title="Make Pre-Sale Tasks Non-editable">
            <Button variant="outlined" onClick={handleClosePSDialog}>Close Pre-Sale</Button>
          </Tooltip>
        ) : (
          <Tooltip title="Make Pre-Sale Tasks Editable">            
            <Button variant="outlined" onClick={handleOpenPSDialog}>Open Pre-Sale</Button>
          </Tooltip>
        )
      ) : (
        <Button variant="outlined" disabled>Pre-Sale Contracted</Button>
      )}
      <Dialog
        open={open}
        onClose={handleCloseDialog}
      >
        <DialogTitle>{dialogTitle}</DialogTitle>
        <DialogContent>
          {dialogTitle === "Close Pre-Sale?" ? (
            <DialogContentText id="alert-dialog-slide-description">
              Setting this to closed will set the status of this lead
              to closed and the pre-sale tasks will not be editable.
            </DialogContentText>
          ) : (
            <DialogContentText id="alert-dialog-slide-description">
              Setting this to open will set the status of this lead
              to open and the pre-sale tasks will be editable again.
            </DialogContentText>
          )}
          <TextField 
            label="Add Explanation" 
            variant="outlined" 
            fullWidth
            value={pmNote}
            onChange={(e) => setPmNote(e.target.value)}
            multiline
            rows={1}
            sx={{ marginTop: 4 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Cancel</Button>
          <Button onClick={handleConfirm}>Confirm</Button>
        </DialogActions>
      </Dialog>
      
    </>
  );
}